import React, { useEffect } from 'react';
import Tab from '../../../Components/Tab/Tab';
import './Delivery.scss';
import { alertRef } from '../../../App';
import { useSelector } from 'react-redux';
import { Outlet, useNavigate } from 'react-router-dom';
import axios from 'axios';

const routeList = {
    '/delivery/area': '배달지역설정',
    '/delivery/fee' : '배달팁설정'
}

const Delivery = (props) => {
    const [ name, setName ] = React.useState('store-info')
    const route = useSelector((state) => state.user.route)
    const navigate = useNavigate();
    
    const tabRoute = [
        { route : 'area', header : '배달지역설정' },
        { route : 'fee', header : '배달팁설정' },
    ]


    return (
        <div className='wrapper'>
            <div className='header-row'>
                <p className='header-text'>오더 {'>'} 배달설정 {'>'}</p>
                <p className='header'>{routeList[route]}</p>
            </div>
            <Tab 
                routes={tabRoute}
                current={route.replace('/delivery/','')}
                onTabChange={(name) => {setName(name);navigate(`/delivery/${name}`)}}
                renderItems={{
                    'area' : <Outlet/>,
                    'fee' : <Outlet/>,
                }}
            />
        </div>
    )
}

export default Delivery;